// Yup
import { object, string } from 'yup';

const sectionSchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  startId: string().required('Campo parada inicial obrigatório'),
  endId: string().required('Campo parada final obrigatório'),
});

export default sectionSchema;
export { sectionSchema };
